import type { Country } from './types';

/**
 * Converts a locally-formatted phone number to E.164 using the selected
 * country's dial code.
 *
 *  - `"+43676…"`  → `"+43676…"`   (already E.164, pass through)
 *  - `"0043676…"` → `"+43676…"`   (00 exit code)
 *  - `"0676…"`    → `"+43676…"`   (local trunk prefix, AT selected)
 *  - `"676…"`     → `"+43676…"`   (no prefix at all, AT selected)
 *
 * If no country is provided and the value doesn't already include an
 * international prefix, returns the stripped digits unchanged.
 */
const resolveToE164 = (
  value: string,
  selectedCountry: Country | undefined
): string => {
  const stripped = value.replace(/[\s\-()]/g, '');

  if (stripped.startsWith('+')) {
    return stripped;
  }
  if (stripped.startsWith('00')) {
    return `+${stripped.slice(2)}`;
  }
  if (!selectedCountry) {
    return stripped;
  }

  const withoutTrunk = stripped.startsWith('0') ? stripped.slice(1) : stripped;
  return `${selectedCountry.prefix}${withoutTrunk}`;
};

export default resolveToE164;
